module.exports = __webpack_public_path__ + "static/outlook_web_6-8437db815c0a49b33633e21c2a2c8f30.png";